import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Settings, Table, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { path: '/', icon: LayoutDashboard, labelKey: 'dashboard.title' },
  { path: '/agents', icon: Users, labelKey: 'agents.title' },
  { path: '/raw-data', icon: Table, labelKey: 'rawData.title' },
  { path: '/settings', icon: Settings, labelKey: 'settings.title' },
];

export function Sidebar() {
  const { t } = useTranslation();

  return (
    <aside className="hidden lg:flex flex-col w-64 bg-white border-e border-gray-200 min-h-[calc(100vh-4rem)]">
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                isActive
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              )
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
